// Mock data for Muze Madhuprabha Constructions Pvt. Ltd. website
export const serviceData = [
  {
    id: 1,
    title: "Structural Design ",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    image: "/service/Structural-Design.jpg",
    description: " We provide comprehensive structural design solutions for all types of buildings and infrastructure projects by applying advanced engineering principles, national and international codes, and modern software tools.",
    points: [
      " Design of residential, commercial, and industrial structures",
      "	Concrete, steel, timber, and masonry structures ",
      "	High-rise buildings and special structures ",
      
     
    ]
  },
  {
    id: 2,
    title: "Structural Analysis",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    image: "/service/service22.png",
     description: "We perform detailed structural analysis to ensure safety, stability, and optimal performance of structures under various loading conditions. ",
     points: [
      "Load calculations (dead, live, wind, seismic) ",
      "	Finite element analysis (FEA)",
      " Structural modeling and optimization",
     
    ]
  },
  {
    id: 3,
    title: "Construction Drawings & Documentation",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    image: "/service/service3.jpg",
    description: "We provide complete structural documentation required for construction and approval. ",
     points: [
      " 	Structural drawings and detailing",
      "	Bar bending schedules (BBS) ",
      "	Technical specifications and design reports ",
     
    ]
  },
  {
    id: 4,
    title: "Structural Assessment & Inspection ",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    image: "/images/About image.jpg",
    description: "We evaluate the condition of existing buildings and structures to determine safety, durability, and performance. ",
     points: [
      "	Condition assessment of existing structures ",
      "	Structural safety and stability evaluations ",
      "	Building damage assessment (cracks, settlement, corrosion)",
     
     
    ]
  },
  {
    id: 5,
    title: "Structural Rehabilitation & Retrofitting",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    image: "/service/service5.webp",
    description: " We specialize in repairing, strengthening, and upgrading existing structures to enhance their lifespan and performance.",
     points: [
      "	Change of building use or load upgrades ",
      " 	Seismic retrofitting",
      " 	Repair and strengthening of damaged structures",
     
    ]
  },
  {
    id: 6,
    title: "Foundation Engineering",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    image: "/project/foundation-engineering.jpg",
    description: "We design reliable foundation systems based on soil and structural interaction. ",
      points: [
      " 	Shallow and deep foundation design",
      " 	Soil–structure interaction analysis",
     
    ]
  },
   {
    id: 7,
    title: "Seismic & Wind Engineering",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    image: "/project/Seismic-&-Wind Engineering.jpg",
    description: " We ensure that structures can safely withstand natural forces such as earthquakes and high winds. ",
      points: [
      " Earthquake-resistant design",
      "Wind load analysis and design ",
      " Performance-based structural design",
     
    ]
  },
   {
    id: 8,
    title: "Construction Support Services",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    image: "/project/Construction_Support_Services.webp",
    description: " We provide technical assistance throughout the construction phase. ",
     points: [
      "	Design review and value engineering ",
      " 	Site visits and construction supervision",
      "Structural problem-solving during construction ",
     
    ]
  
  },
   {
    id: 9,
    title: "Temporary Structures",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    image: "/project/temporary-tent-structures.webp",
    description: " We design safe and stable temporary structures required during construction. ",
     points: [
      "	Temporary support systems ",
      " 	Design of scaffolding, formwork, and shoring",
     
    ]
 
  },
   {
    id: 10,
    title: "Compliance & Certification",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    image: "/project/Compliance-Training.jpg",
    description: " We help clients meet legal and technical requirements for construction projects. ",
  
     points: [
      " 	Code compliance checks",
      "	Structural stability certificates ",
      "	Peer review and third-party verification ",
      
     
    ]
  },
   {
    id: 11,
    title: "Specialized Services",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    image: "/project/Specialized-Services.png",
    description: " We offer expert structural solutions for complex and industrial projects. ",
     points: [
      "	PT Design services ",
      "	Pre-engineered buildings (PEB) ",
      "	Bridges and infrastructure structures ",
      " Industrial structures (tanks, silos, chimneys)",
     
    ]
  
  },
];


export const projectsData = [
  {
    id: 1,
    title: "Bastar University Raipur ",
    location: "Raipur (C.G)",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    architecture: "AR. SANDEEP SHRIVASTAVA",
    vastuConsultant: "Kirti Bhai",
    area: "3,50,000 SQ.FT.",
    type: "INSTITUTIONAL BUILDING",
    status: "Ongoing",
    floors:"G + 3",
    image: "/aaj-home/baskar-university-raipuer.jpeg",
    descriptionImage: "/aaj-home/baskar-university-raipuer.jpeg",
    fullDescription: "Bastar University, officially known as Shaheed Mahendra Karma Vishwavidyalaya, is a distinguished state public university located in Jagdalpur, Chhattisgarh, India. Established in 2008, it serves as a key centre for higher education in the tribal-dominated Bastar region, offering a broad spectrum of undergraduate, postgraduate, diploma, and doctoral programmes across departments such as Management, Computer Applications, Social Work, Anthropology, and Forestry.",
    // description: "Introducing ‘PRAJAKTA La-Maison’, our 7 level 3 & 4 BHKD ultra luxurious view apartment with strategic location based on European theme, where every movement feels like parision escape, where every day is a celebration of charm with modern amenities at Nagpur. ",
    completionDate: "2025-12-31",
    brochureURL: "/images/PRAJAKTA LA MAISON_.pdf",
    locationUrl: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3722.1884976569895!2d79.0614009752587!3d21.105049880563453!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMjHCsDA2JzE4LjIiTiA3OcKwMDMnNTAuMyJF!5e0!3m2!1sen!2sin!4v1760604126508!5m2!1sen!2sin",
    features: [
      "Grand entrance lobby on ground floor",
      "CCTV Cameras in ground floor lobby are parking area",
      "Password protected ground floor lobby area.",
      "Video Door Phones for individual flats",
      "Safety Doors to all flats",
      "Digital locks for secured home.",
      "2 Allotted car park (1 SUV car park) to Individual flat owners.",
      "French Themed elevation."

    ],
    gallery: [
      "/aaj-home/baskar-university-raipuer.jpeg",
      "/aaj-home/baskar-university-raipuer.jpeg",
      "/aaj-home/baskar-university-raipuer.jpeg",
      "/aaj-home/baskar-university-raipuer.jpeg",
      "/aaj-home/baskar-university-raipuer.jpeg",
      "/aaj-home/baskar-university-raipuer.jpeg",
      
    ],
    videoURL: "/La-maison-gallary/main-video.mp4",
    // currentProjectsData: [
    //   "/La-maison-gallary/la_maison5.jpg",
    //   "/La-maison-gallary/la_maison6.jpg",
    //   "/La-maison-gallary/la_maison7.jpg",
    //   "/La-maison-gallary/la_maison8.jpg",
    //   "/La-maison-gallary/currentstatus1.jpeg",
    //   "/La-maison-gallary/currentstatus2.jpeg",
    //   "/La-maison-gallary/currentstatus3.jpeg",
    //   "/La-maison-gallary/currentstatus4.jpeg",
    //   "/La-maison-gallary/currentstatus5.jpeg",
    // ]
  },
  {
    id: 2,
    title: "Embassy ll, Ms Kukreja Infrastructure, Nagpur",
    location: "Nagpur",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    architecture: "AR. LOKESH KADU",
    area: "1,53,000 SQ.FT.",
    type: "Residential",
    floors:"B + G + 15",
    status: "Ongoing",
    image: "/aaj-home/1-1.jpg",
    // tagline: "Prajakta Park – A perfect harmony of nature, comfort, and modern living..",
    // descriptionImage: "/prajkta-park-removebg-preview.png",
    fullDescription: " Embassy II is an upcoming premium residential project developed by Kukreja Infrastructure in Jaripatka / Byramji Town, Nagpur. Designed for luxury living, it features spacious 4-BHK and 4.5-BHK apartments within a single high-rise tower, combining modern architecture with elegant interiors and panoramic views.",
    description: "  Park facing apartments thoughtfully designed residential project that blends nature with modern living. Prajakta Park offers spacious homes surrounded by greenery, ensuring peace and comfort in every corner. With premium amenities, excellent connectivity, and a vibrant community, it is the perfect place to create memories and celebrate life every day.",
    completionDate: "2025-12-31",
    brochureURL: "/images/Prajakta-Park-E-Brochure-New-1_compressed (1)(final).pdf",
    features: [
      "Lift with inverter Back Up.",
      "Allotted car park to individual flat owners.",
      "Automatic level water controller to give uninterrupted water supply.",
      "Branded modular switches.",
      "Elegant elevation.",
      "AC points in all the three bed rooms.",
      "100% Vastu compliance.",
      "CCTV Cameras.",
      "Video Door Phones for individual flats.",
      "Intercom Connectivity.",

    ],
    gallery: [
      "/aaj-home/1-1.jpg",
      "/aaj-home/haldiram.png",
      "/aaj-home/1-1.jpg",
      "/aaj-home/1-1.jpg",
      "/aaj-home/1-1.jpg",
    

    ],
     videoURL: "/La-maison-gallary/main-video.mp4",
  },
    {
    id: 3,
    title: 'Nirmal Trinity Towers At Umred Road',
    location: 'Umred Road, Nagpur',
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    architecture: "AR. HARISH CHANDANI",
    area: "6,00,000 SQ.FT. (11 TOWER)",
    type: "Residential",
    status: "Ongoing",
    floors:"B + G + 27",
    image: '/aaj-home/nirmal-trinity.jpeg',
    tagline: 'Enjoy The Blissful Life in the Harmony of Mother Nature.',
    fullDescription: "Nirmal Trinity Towers is a modern residential project situated on Umred Road in Nagpur, developed by The Nirmal Ujjwal Credit Cooperative Society. It offers well-designed 2 BHK and 3 BHK apartments with contemporary layouts and essential amenities tailored for comfortable urban living. The development spans over a substantial area and includes features such as club house, children’s play area, jogging track, community hall, and 24×7 water supply, making it suitable for families seeking a balanced lifestyle. Scheduled for possession in December 2028.",

    description: "Introducing ‘PRAJAKTA GREENFINITY’, our 7 level 3 BHKD luxurious greenery view apartment located in the lap of nature. ",
    completionDate: "2023-12-31",
    gallery: [
      "/aaj-home/nirmal-trinity.jpeg",
      "/aaj-home/nirmal-trinity.jpeg",
      "/aaj-home/nirmal-trinity.jpeg",
      "/aaj-home/nirmal-trinity.jpeg",
    ],
     features: [
      "Lift with inverter Back Up.",
      "Allotted car park to individual flat owners.",
      "Automatic level water controller to give uninterrupted water supply.",
      "Branded modular switches.",
      "Elegant elevation.",
      "AC points in all the three bed rooms.",
      "100% Vastu compliance.",
      "CCTV Cameras.",
      "Video Door Phones for individual flats.",
      "Intercom Connectivity.",

    ],
    videoURL: "/prajakta_greenfinity/greenfinity.mp4"
  },
  {
    id: 4,
    title: "NMC Devadiya Hospital Queta Colony, Nagpur ",
    location: "Queta Colony, Nagpur",
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    architecture: "AR. ASHOK MOKHA",
    area: "62,000 SQ.FT.",
    type: "HOSPITAL BUILDING",
    status: "Ongoing",
    floors:"G + 7",
    image: "/aaj-home/nmc-devadiya-hospital.jpeg ",
    tagline: "Classical theme based Spacious flats with garden and parking facility.",
    fullDescription: "Devadiya Hospital refers to a civic healthcare development initiative in the Quetta Colony area of Nagpur, where the Nagpur Municipal Corporation has plans for constructing a modern hospital facility. The project involves building a new healthcare complex aimed at improving local medical infrastructure and services for residents of this mixed residential and industrial zone. Historically, the area included an older Devadiya hospital structure that had become dilapidated and unused, leading to renewed efforts by authorities to redevelop the site into a functioning public hospital.",
    description: "An exclusive collection of 5 meticulously designed hand-sculpted 3 BHKD apartments.This based on classical theme with modern conveniences across 1800 sq ft of thoughtfully designed space.",
    completionDate: "2024-12-31",
    gallery: [
      "/aaj-home/nmc-devadiya-hospital.jpeg",
      "/aaj-home/nmc-devadiya-hospital.jpeg",
      "/aaj-home/nmc-devadiya-hospital.jpeg",
      "/aaj-home/nmc-devadiya-hospital.jpeg",
      
    ],
      features: [
      "Lift with inverter Back Up.",
      "Allotted car park to individual flat owners.",
      "Automatic level water controller to give uninterrupted water supply.",
      "Branded modular switches.",
      "Elegant elevation.",
      "AC points in all the three bed rooms.",
      "100% Vastu compliance.",
      "CCTV Cameras.",
      "Video Door Phones for individual flats.",
      "Intercom Connectivity.",

    ],
    videoURL: "/prajakta_classic_video/prajkata-classic_video.mp4"
  },
  {
    id: 5,
    title: 'Vidhan Bhavan At Nava Raipur',
    location: 'Nava, Raipur',
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    architecture: "AR. SANDEEP SHRIVASTAVA",
    area: "8,00,000 SQ.FT.",
    floors:"G + 2/3",
    type: "MODERN ASSEMBLY BUILDING",
    status: "Completed",
    image: "/aaj-home/vidhan-bhavan.jpeg",
    tagline: 'An expansive retail complex designed with modern entertainment zones and hassle-free parking solutions.',
    fullDescription: `Vidhan Bhavan at Nava Raipur (Atal Nagar) is the newly inaugurated Legislative Assembly building of the state of Chhattisgarh. Spread across a large campus, this state-of-the-art complex serves as the centre for lawmaking and governance, symbolising democratic values and regional development. The modern facility, built with sustainable features like solar energy and rainwater harvesting, was inaugurated on 1 November 2025 as part of the state’s Silver Jubilee celebrations. It represents both architectural progress and the evolving political importance of Chhattisgarh’s legislative processes.`,
    description: "Luxurious 3 BHKD flats, where comfort meets elegance. Designed with thoughtful planning and premium amenities.",
    completionDate: "2023-12-31",
    gallery: [
      "/aaj-home/vidhan-bhavan.jpeg",
      "/aaj-home/vidhan-bhavan.jpeg",
      "/aaj-home/vidhan-bhavan.jpeg",
      "/aaj-home/vidhan-bhavan.jpeg",
      "/aaj-home/vidhan-bhavan.jpeg",

    ],
     features: [
      "Lift with inverter Back Up.",
      "Allotted car park to individual flat owners.",
      "Automatic level water controller to give uninterrupted water supply.",
      "Branded modular switches.",
      "Elegant elevation.",
      "AC points in all the three bed rooms.",
      "100% Vastu compliance.",
      "CCTV Cameras.",
      "Video Door Phones for individual flats.",
      "Intercom Connectivity.",

    ],
    videoURL: "/greenSerenity/greenserenity.mp4"
  },
 {
    id: 6,
    title: ' Haldiram Om Tatsat (2B + G + 29)',
    location: 'Nagpur',
    fonts: {
      title: "Cinzel, serif",
      status: "Julee, cursive",
      tagline: "Merriweather, serif"
    },
    architecture: "M/S SANDEEP DWELLERS PVT. LTD",
    area: "4,50,000 SQ.FT.",
    type: "Commercial",
    floors:"B1 + B2 + G + 30",
    status: "Ongoing",
    image: "/aaj-home/haldiram.png",
    tagline: 'An expansive retail complex designed with modern entertainment zones and hassle-free parking solutions.',
    fullDescription: `Haldiram Om Tatsat is a premium residential project by Sandeep Dwellers Pvt. Ltd. located in Chikhali / Shantinagar Colony, Nagpur. It is designed to offer spacious 3 BHK and 4 BHK apartments with modern layouts and quality finishes, making it ideal for families looking for comfortable urban living. The development is spread across around 1.14 acres, combining thoughtful architecture with resident-friendly amenities such as gymnasium, children’s play area, swimming pool, landscaped greens, security, and more, fostering a community-centric lifestyle.`,
    description: "Luxurious 3 BHKD flats, where comfort meets elegance. Designed with thoughtful planning and premium amenities.",
    completionDate: "2023-12-31",
    floors:"",
    gallery: [
      "/aaj-home/Haldiram.jpg",
      "/aaj-home/Haldiram.jpg",
      "/aaj-home/Haldiram.jpg",
      "/aaj-home/Haldiram.jpg",
     

    ],
     features: [
      "Lift with inverter Back Up.",
      "Allotted car park to individual flat owners.",
      "Automatic level water controller to give uninterrupted water supply.",
      "Branded modular switches.",
      "Elegant elevation.",
      "AC points in all the three bed rooms.",
      "100% Vastu compliance.",
      "CCTV Cameras.",
      "Video Door Phones for individual flats.",
      "Intercom Connectivity.",

    ],
    videoURL: "/greenSerenity/greenserenity.mp4"
  },
];

export const currentProjectsData = [
  {
    id: 15,
    title: "3BHK Luxurious Prajakta Park",
    location: "Abhyankar Nagar, Nagpur",
    type: "Residential",
    status: "In Progress",

    image: "/images/HDPHOTO1.png",
    tagline: "A 5 level 3 BHKD luxurious park view apartment located in the lap of nature. A peaceful location in the heart of the city where you can enjoy your mornings with blissful greenery. A Perfect Home with Modern Amenities at Abhyankar Nagar, Nagpur.",
    fullDescription: "Currently under construction, this prestigious 5-floor luxury apartment complex will feature 40 premium units with breathtaking city views. The project includes a sky lounge, infinity pool, fitness center, and landscaped gardens. Each apartment is designed with premium finishes and smart home features.",
    features: [
      "40 luxury apartments (2-4 BHK)",
      "5-floor high-rise building",
      "Sky lounge with city views",
      "Infinity pool and deck",
      "State-of-the-art fitness center",
      "Landscaped podium gardens",
      "5-level basement parking",
      "24/7 concierge service"
    ],
    gallery: [
      "https://ashishconstruction.in/wp-content/uploads/2025/07/IMG-20250703-WA0008.jpg",
      "https://ashishconstruction.in/wp-content/uploads/2025/07/IMG-20250703-WA0008.jpg",
    ]
  },
  {
    id: 16,
    title: "3BHK Luxurious Prajakta La-Masion",
    location: "Pandey Layout, Nagpur",
    type: "Residential",
    status: "In Progress",
    image: "https://madhuprabhaconstructions.in/images/secondProject.jpg",
    tagline: "A 7 level 3 BHKD luxurious view apartment located in the lap of nature. A peaceful location in the heart of the city where you can enjoy your mornings with blissful greenery. A Perfect Home with Modern Amenities at Nagpur.",
    features: [
      "6 individual eco-villas",
      "4 bedrooms with valley views",
      "Solar power generation",
      "Rainwater harvesting systems",
      "Natural stone and wood finishes",
      "Private infinity pools",
      "Organic kitchen gardens",
      "Electric vehicle charging"
    ],
    gallery: [
      "https://ashishconstruction.in/wp-content/uploads/2025/07/IMG-20250703-WA0008.jpg",
      "https://ashishconstruction.in/wp-content/uploads/2025/07/IMG-20250703-WA0008.jpg",
    ]
  },

];

export const galleryImages = [
  {
    id: 1,
    url: "/aaj-home/baskar-university-raipuer.jpeg ",
    title: "aaj-engineer",
    category: "image"
  },
  {
    id: 2,
    url: "/aaj-home/carousal-build2.jpg ",
    title: " aaj-engineer",
    category: "image"
  },
  {
    id: 3,
    url: "/aaj-home/embassyll-ms-kukreja-infrastructure.jpeg ",
    title: " aaj-engineer",
    category: "image"
  },
  {
    id: 4,
    url: "/aaj-home/nirmal-trinity.jpeg ",
    title: " aaj-engineer",
    category: "image"
  },
  {
    id: 5,
    url: "/aaj-home/title-logo.jpeg",
    title: " aaj-engineer",
    category: "image"
  },
  {
    id: 6,
    url: "/aaj-home/nirmal-trinity.jpeg",
    title: " aaj-engineer",
    category: "image"
  },
  {
    id: 7,
    url: "/aaj-home/vidhan-bhavan.jpeg",
    title: " aaj-engineer",
    category: "image"
  },
  {
    id: 8,
    url: "/aaj-home/nmc-devadiya-hospital.jpeg ",
    title: " aaj-engineer",
    category: "image"
  },
  // {
  //   id: 9,
  //   url: " ",
  //   title: " aaj-engineer",
  //   category: "image"
  // },

];

// export const galleryVideos = [
//   {
//     id: 1,
//     title: "Construction Phase",
//     thumbnail:"/images/Ashish-Construction-09-13-2025_07_43_PM.png",
//     duration: "3:42",
//     url: "https://www.youtube.com/embed/UpdIzsq1G6w?si=SU9z3WPDFPVdchHL"
//   },
// ];

export const galleryVideos = [
  // {
  //   id: 1,
  //   title: "Construction Phase",
  //   thumbnail: "/images/Ashish-Construction-09-13-2025_07_43_PM.png",
  //   duration: "3:42",
  //   url: "https://www.youtube.com/embed/UpdIzsq1G6w?si=SU9z3WPDFPVdchHL", 
  // },
  {
    id: 2,
    title: "Downloaded Phase Video",
    thumbnail: "/images/video_thumbnail.png", // optional thumbnail
    duration: "2:30",
    url: "p_greenfinity.mp4",
  },
  {
    id: 3,
    title: "Another MP4 Video",
    thumbnail: "/images/video_thumbnail2.png",
    duration: "1:50",
    url: "p_ikebena.mp4",
  },
  {
    id: 3,
    title: "Another MP4 Video",
    thumbnail: "/images/video_thumbnail2.png",
    duration: "1:50",
    url: "p_serenety.mp4",
  },
];


export const testimonials = [
  {
    id: 1,
    name: "Dr. Ankita Randhir",
    location: "Nagpur",
    rating: 5,
    text: "Very good and well contructed project.Happy with the interior and furniture of gym and party area.Satisfied with the builders and his staff regarding cooperation",
  },
  {
    id: 2,
    name: "Manoj Sharma",
    location: "Nagpur",
    rating: 5,
    text: "An absolutely phenomenal project with amazing construction quality",

  },
  {
    id: 3,
    name: "Dinesh Badoniya",
    location: "Nagpur",
    rating: 5,
    text: "The construction of the scheme is very good, there is adequate lighting, full care has been taken of sunlight, the outer look and arrangement is very excellent.",

  },

];

export const aboutUsData = {
  title: "About Madhu Prabha Construction",
  shortDescription: "Leading residential construction company with 20 Glorious Years of experience in creating quality construction.",
  fullDescription: ` Madhuprabha Constructions Pvt. Ltd. was started in the year 2005 by the name of Ashish Construction. The business start was modest with the regular clients in Nagpur. Over the period, in last 20 years, now we are the leading company in the construction group. Our projects not only deal in Nagpur but also in and around Central India. The journey of hard work, dedication, and trust of our clients has brought us this long way. We deal in the commercials and housing society. With the experience in designing and building these, our company has higher standards in terms of quality and at the same time, it remains affordable to everyone. We are also very well known for the perfect carvings and core commitment for every project. With this, we believe to have a futuristic approach so that our work completion is on time for every project undertaken. We also commit the designing a housing society and commercial complex for a progressive India and we adhere to our traditional values which make a place better to live in, with positivity and peace. Quality and transparency are our main criteria. Ashish Constructions is known for its quality factor and service. We do firmly believe that a house is made of walls and beams, but a home is built with love and dreams.

Success is a state of mind. Anything you want, you can have! You just need to have dreams; believe that you deserve those dreams, and work hard to acquire them! This is a motivational factor for our company.`,

  experience: "20 Glorious Years",
  projectsCompleted: "25+",
  happyClients: "200+",
  awards: "25+",
  location: "Nagpur, Maharashtra",
  image: "https://madhuprabhaconstructions.in/images/about.jpg"
};

export const contactData = {
  address: "Block no 502, Tirupati Enclave Opposite Ramnagar Bus Stop, Ram Nagar Nagpur 440010",
  phone1: "+91 9970066936",
  // phone2: "+91 99700 66936",
  email: "info@aajengineersconsultants.in",
  email2: "aaj2007@gmail.com",
  googleMapsUrl: "https://www.google.com/maps/place/AAJ+Engineers+%26+Consultants/@21.1407185,79.0558243,17z/data=!4m6!3m5!1s0x3bd4bf871c9d807d:0x3b96399c20931d50!8m2!3d21.1407193!4d79.0558201!16s%2Fg%2F1vd3t7jn?hl=en&entry=ttu&g_ep=EgoyMDI2MDEyNy4wIKXMDSoASAFQAw%3D%3D",
  workingHours: "Mon - Sat: 9:00 AM - 6:00 PM",
};
// export const contactSecondData = {
//   address: "Ashish Annex, 302, Plot No J 13 A, Scientific Society,WHC Road, Laxmi Nagar, Nagpur-2",
//   phone1: "+91 95229 01659",
//   phone2: "+91 99700 66936",
//   email: "info@madhuprabhaconstructions.in",
//   googleMapsUrl: "https://www.google.com/maps/place/UMA+Apartment,+Tilak+Road,+Mahal,+Nagpur",
//   workingHours: "Mon - Sat: 9:00 AM - 6:00 PM",
// };